const desktopHover = window.matchMedia('(hover: hover) and (pointer: fine)');

document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
  const details = menu.querySelector(':scope > details');
  if (!details) return;
  const summary = details.querySelector(':scope > summary');

  const open = () => {
    if (!desktopHover.matches) return;
    details.open = true;
    summary?.setAttribute('aria-expanded', 'true');
  };
  const close = () => {
    details.open = false;
    summary?.setAttribute('aria-expanded', 'false');
  };

  menu.addEventListener('pointerenter', open);
  menu.addEventListener('pointerleave', close);
  menu.addEventListener('focusin', () => {
    details.open = true;
    summary?.setAttribute('aria-expanded', 'true');
  });
  menu.addEventListener('focusout', (event) => {
    if (!menu.contains(event.relatedTarget)) close();
  });
});
